var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedNonPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H0V0Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45583 7.69297C3.45583 5.0753 5.578 2.95312 8.19568 2.95312C9.49826 2.95312 10.6781 3.47943 11.5347 4.33026L11.5356 4.32981C11.5356 4.32981 13.1426 5.62615 13.1426 8.03982C13.1426 10.453 11.1111 13.0497 8.19568 13.0497H2.88623C2.85498 13.0497 2.84873 13.0404 2.86748 13.0216C2.95319 12.9368 3.22504 12.6676 3.56609 12.3266C4.05891 11.8342 4.26247 11.4543 4.26247 10.8611C4.26247 10.5245 4.15935 10.1781 4.0665 10.0218C4.066 10.0211 4.06606 10.0197 4.06614 10.0183C4.06619 10.0172 4.06625 10.0161 4.06606 10.0151C3.67903 9.32857 3.45583 8.53755 3.45583 7.69297ZM5.41046 7.42183C5.1873 7.64498 5.1873 8.00679 5.41046 8.22995L7.20225 10.0217L7.25209 10.0661C7.47639 10.2438 7.80315 10.229 8.01037 10.0217L11.2429 6.78925C11.466 6.56609 11.466 6.20428 11.2429 5.98112C11.0197 5.75797 10.6579 5.75797 10.4347 5.98112L7.60613 8.80937L6.21858 7.42183C5.99543 7.19867 5.63362 7.19867 5.41046 7.42183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedNonPriority);
export default __webpack_public_path__ + "static/media/closed-non-priority.d79a45234aec8462434b255ae96c8adf.svg";
export { ForwardRef as ReactComponent };